<template>
    <b-modal size="lg" v-model="itemVisible" @ok="handleOk" class="pt-8" body-class="p-2" centered header-class="p-0"
        footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
        <template #modal-title>
            <div class="title-block text-center p-2">{{ title }}</div>
        </template>
        <template #default>
            <div class="create-item-popup">
                <!-- <officer-master-items v-if="useOfficerList" :officer-master-items="officerMasterItems"
                    v-model="selectedItems" /> -->
                <b-form ref="form" @submit.stop.prevent="handleSubmit">
                    <!-- <portal to="generalItemView"> -->
                        <b-row>
                            <b-col cols="12" class="mt-3">
                                <label class="mb-3"><strong>{{
                                    $translate('asset')
                                }}</strong></label>
                                <div class="create-select">
                                            <vue-typeahead-bootstrap v-model="searchedAsset" :data="assets" :serializer="s => `${s?.name} - ${s?.serial_no} - ${s?.model_no}`
                                            " @hit="setAsset" @queryOptionsValue="queryOptionsValue" @input="lookupAssets"
                                            :disabled="itemModel.id > 0"
                                            :placeholder="$translate('search_assets')" 
                                            backgroundVariant="list-group-item list-group-item-light" />
                                </div>
                            </b-col>
                            <b-col cols="6" class="mt-3">
                                <label class="mb-3">
                                    <strong>{{
                                        $translate('asset_description')
                                    }}</strong>
                                </label>
                                <b-form-input type="text" id="input-asset_description"
                                v-model="itemModel.asset_description" disabled></b-form-input>
                            </b-col>
                            <b-col cols="6" class="mt-3">
                                <label class="mb-3">
                                    <strong>{{
                                        $translate('master_item_type')
                                    }}</strong>
                                </label>
                                <b-form-input type="text" id="input-master_item_type"
                                v-model="itemModel.master_item_type" disabled></b-form-input>
                            </b-col>
                            <b-col cols="6" class="mt-3">
                                <label class="mb-3">
                                    <strong>{{
                                        $translate('start_rental_at')
                                    }}</strong>
                                </label>
                                <b-form-input type="datetime-local" id="input-transaction_date"
                                v-model="itemModel.start_rental_at" :disabled="isReturnMode"></b-form-input>
                            </b-col>
                            <b-col cols="6"  class="mt-3">
                                <label class="mb-3"><strong>{{
                                    $translate('estimated_rental_days')
                                }}</strong></label>
                                <b-form-input id="input-estimated_rental_days" name="input-estimated_rental_days"
                                    :placeholder="$translate('estimated_rental_days')" type="number" v-model="itemModel.estimated_rental_days" :disabled="isReturnMode"
                                    />
                            </b-col>
                            <b-col cols="6"  class="mt-3">
                                <label class="mb-3"><strong>{{
                                    $translate('estimated_rental_date')
                                }}</strong></label>
                                <b-form-input id="input-estimated_rental_date" name="input-estimated_rental_date"
                                    :placeholder="$translate('estimated_rental_date')" type="datetime-local" v-model="estimatedRentalDate"
                                    disabled/>
                            </b-col>
                            <b-col cols="6"  class="mt-3">
                                <label class="mb-3"><strong>{{
                                    $translate('estimated_rental_rate')
                                }}</strong></label>
                                <b-form-input id="input-estimated_rental_rate" name="input-estimated_rental_rate"
                                    :placeholder="$translate('estimated_rental_rate')" type="number" v-model="itemModel.estimated_rental_rate" :disabled="isReturnMode"
                                    />
                            </b-col>
                            
                            <b-col cols="6"  class="mt-3">
                                <label class="mb-3"><strong>{{
                                    $translate('tax_rate')
                                }}</strong></label>
                                <b-form-input id="input-tax_rate" name="input-tax_rate"
                                    :placeholder="$translate('tax_rate')" type="number" v-model="itemModel.tax_rate" :disabled="isReturnMode"
                                    :step="0.01"/>
                            </b-col>
                            <b-col cols="6"  class="mt-3">
                                <label class="mb-3"><strong>{{
                                    $translate('estimated_total_rental_tax')
                                }}</strong></label>
                                <b-form-input id="input-estimated_total_rental_tax" name="input-estimated_total_rental_tax"
                                    :placeholder="$translate('total_tax')" type="number" v-model="itemModel.estimated_total_rental_tax" :disabled="true"
                                    />
                            </b-col>
                            <b-col cols="6"  class="mt-3">
                                <label class="mb-3"><strong>{{
                                    $translate('estimated_total_rental_rate')
                                }}</strong></label>
                                <b-form-input id="input-estimated_total_rental_rate" name="input-estimated_total_rental_rate"
                                    :placeholder="$translate('estimated_total_rental_rate')" type="number" v-model="estimatedTotal"
                                    disabled/>
                            </b-col>
                            <b-col cols="12" class="mt-3" v-if="isReturnMode">
                            <h2 class="mb-0 mt-2">{{ $translate('return_details') }}</h2>
                            </b-col>
                            <b-col cols="6" class="mt-3" v-if="isReturnMode">
                                <label class="mb-3">
                                    <strong>{{
                                        $translate('actual_returned_at')
                                    }}</strong>
                                </label>
                                <b-form-input type="datetime-local" id="input-actual_returned_at"
                                v-model="itemModel.actual_returned_at" :min="itemModel.start_rental_at"></b-form-input>
                            </b-col>
                            <b-col cols="6"  class="mt-3" v-if="isReturnMode">
                                <label class="mb-3"><strong>{{
                                    $translate('actual_rental_rate')
                                }}</strong></label>
                                <b-form-input id="input-actual_rental_rate" name="input-actual_rental_rate"
                                    :placeholder="$translate('actual_rental_rate')" type="number" v-model="itemModel.actual_rental_rate" 
                                    />
                            </b-col>
                            <b-col cols="6"  class="mt-3" v-if="isReturnMode">
                                <label class="mb-3"><strong>{{
                                    $translate('actual_total_rental_rate')
                                }}</strong></label>
                                <b-form-input id="input-actual_total_rental_rate" name="input-actual_total_rental_rate"
                                    :placeholder="$translate('actual_total_rental_rate')" type="number" v-model="actualTotal"
                                    disabled/>
                            </b-col>
                            <b-col cols="6"  class="mt-3" v-if="isReturnMode">
                                <label class="mb-3"><strong>{{
                                    $translate('actual_total_rental_tax')
                                }}</strong></label>
                                <b-form-input id="input-actual_total_rental_tax" name="input-actual_total_rental_tax"
                                    :placeholder="$translate('actual_total_rental_tax')" type="number" v-model="itemModel.rental_tax" :disabled="true"
                                    />
                            </b-col>
                            <b-col cols="6" class="mt-3" v-if="isReturnMode">
                                <label class="mb-3"><strong>{{ $translate('return_location') }}
                                </strong></label>
                                <location-section ref="locationSectionRef" v-if="companySetting && companySetting.customer_id" :sectionOnly="true" v-model="itemModel.location_section_id"
                                @set-location-section="(evt) => { setLocationData(evt, 'locationData') }" :hide-controls="true" title="" :modal-title="$translate('location')"
                                :is-modal="true" :customer_id="companySetting?.customer_id ?? -1">
                                    <template #default="{ setSearchMode, hideModal }">
                                        <b-card-footer>
                                            <div class="d-flex gap-2 mb-3 mt-3 justify-content-center">


                                                <b-button @click="setSearchMode()" variant="info">{{ $translate("locations") }}
                                                </b-button>
                                                <b-button class="mr-2" variant="info" @click="hideModal()">{{ $translate("submit") }}</b-button>

                                            </div>
                                        </b-card-footer>
                                    </template>
                                </location-section>
                            </b-col>
                            <b-col cols="6"  class="mt-3" v-if="isReturnMode">
                                <label class="mb-3"><strong>{{
                                    $translate('return_notes')
                                }}</strong></label>
                                <b-form-textarea id="input-return_notes" name="input-return_notes"
                                    :placeholder="$translate('enter_return_notes')" v-model="itemModel.return_notes"/>
                            </b-col>
                        </b-row>
                </b-form>
            </div>
        </template>
        <template #modal-footer="{ ok }">
            <div class="mt-3 d-flex">
                <b-button :disabled="submitting" variant="info" @click="itemVisible = false" class="m-1">{{ $cancelLabel()
                }}</b-button>
                <b-button :disabled="submitting" variant="info" class="m-1" @click="ok">{{ submitTitle }}</b-button>
            </div>
        </template>
    </b-modal>
</template>

<script lang="js">
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import locationMixins from "@/mixins/locationMixins"
import { debounce } from 'lodash'
import moment from 'moment'

import VueTypeaheadBootstrap from '@/components/VueTypeAhead/VueTypeaheadBootstrap'
import LocationSection from "@/views/Location/LocationSection";
// import MasterItemTypeAhead from '@/components/MasterItemTypeAhead'
// import OfficerMasterItems from './OfficerMasterItems.vue'
// import ViewTask from './ViewTask.vue'

const defaultItemModel = Object.freeze({
    id: null,
    name: '',
    order_item_type_id: null,
    asset_id: null,
    hash: null,
    description: '',
    section_from_id: null,
    section_to_id: null,
    quantity: 0,
    uom: null,
    price: 0,
    tax_rate: 0,
    assets: [],
    task_value: null,
    task_checked: 0,
    task_notes: '',
    start_rental_at: moment().format("YYYY-MM-DD H:mm"),
    estimated_rental_days : null,
    estimated_rental_rate : null,
    estimated_total_rental_tax : null,
    estimated_total_rental_rate : null,
    actual_returned_at: null,
    actual_rental_rate: null,
    actual_total_rental_amount: null,
    rental_tax : null,
    return_notes: null,
    is_returned: false,
    asset: null,
    master_item_type:null,
    location_section_id: null,
})

const system_message = 'system_selected'
const warehouse_message = 'select_section'
const blackhole_message = 'none'

export default {
    name: 'orders-ViewItem',
    components: {
        // MasterItemTypeAhead,
        LocationSection,
        VueTypeaheadBootstrap,
        // OfficerMasterItems,
        // ViewTask,
    },
    mixins: [popupMixins, permissionsMixins, locationMixins],
    props: [ 'orderModel'],
    data() {
        return {
            searchedAsset: "",
            filters: {
                can_be_rented: 1,
                is_rented: 0,
                queryOptionsValue: 'starts_with',
            },
            selectedItems: [],
            locationCollapseVisible: false,
            assetCollapseVisible: false,

            isReturnMode: false,
            itemVisible: false,
            submitting: false,
            salesTax: 0,

            itemModel: {},
            locationData: {},

            //////

            system_message,
            warehouse_message,
            blackhole_message,
            masterItem: {},
            asset: {},

            ///////////////
            reference_no: null,
            viewMode: true,
            order_type_id: null
        }
    },

    filters: {
    },

    computed: {
        title() {
            if (this.isNew) {
                return this.itemModel.hash
                    ? this.$translate('edit_rental')
                    : this.$translate('create_rental')
            } else {
                const orderItemTitle = this.isReturnMode ? this.$translate('return_rental') : this.$translate('edit_rental')
                return orderItemTitle
            }
        },

        useOfficerList() {
            return this.isOfficerEntity && !this.itemModel.id
        },
        isNew() {
            return !(this.itemModel.id > 0)
        },

        order_id() {
            return this.orderId || this.$route.params.id
        },
        submitTitle() {
            console.log('this.itemModel', this.itemModel)
            return this.itemModel.hash && this.submitting && this.isReturnMode 
                ? this.$translate('returning_item') 
                : this.itemModel.hash && this.isReturnMode 
                ? this.$translate('return_item') 
                : this.itemModel.hash && this.submitting
                ? this.$translate('updating_item')
                : this.itemModel.hash
                    ? this.$translate('update_item')
                    : this.submitting
                        ? this.$translate('creating_item')
                        : !this.useOfficerList ||
                            (this.useOfficerList && this.selectedItems.length == 1)
                            ? this.$translate('create_item')
                            : this.$translate('create_items')
        },

        isCompleted() {
            return !!this.orderModel.completed
        },

        storedItems() {
            return this.$store.state.orderRentalAssetStore.items
        },
        assets() {
            return this.$store.state.assets.assets
        },

        // itemTypes() {
        //     return this.$store.state.itemType.items
        // },
        // orderTypes() {
        //     return this.$store.state.orderType.items
        // },
        // orderType() {
        //     const { orderTypes } = this
        //     if (orderTypes && orderTypes.length > 0 && this.order_type_id) {
        //         return orderTypes.find(x => x.id === this.order_type_id)
        //     }

        //     return null // or return a default object or value, if desired
        // },
        // itemType() {
        //     console.log("......................>>>>>>>>>>>>>>", this.itemModel)
        //     const { order_item_type_id } = this.itemModel
        //     if (!order_item_type_id)
        //         return {
        //             is_discount: true,
        //         }
        //     else
        //         return (
        //             this.itemTypes.find(x => order_item_type_id === x.id) || {}
        //         )
        // },
        // isTask() {
        //     return !!this.itemType.is_task
        // },

        // isOrderItem() {
        //     return !!this.itemType.is_order_item
        // },

        estimatedRentalDate() {
            if (!this.itemModel.start_rental_at || !this.itemModel.estimated_rental_days) {
                return null;
            }

            const startDate = new Date(this.itemModel.start_rental_at);
            const estimatedDays = parseInt(this.itemModel.estimated_rental_days);

            let estimatedDate = new Date(startDate.getTime() + estimatedDays * 24 * 60 * 60 * 1000);

            // Return the estimated date in the format accepted by datetime-local input
            return estimatedDate.toISOString().slice(0, 16);
        },

        estimatedTotal(){
            if (!this.itemModel.estimated_rental_rate || !this.itemModel.estimated_rental_days) {
            return null;
            }
            const estimated_total_rate = parseInt(this.itemModel.estimated_rental_days) * parseFloat(this.itemModel.estimated_rental_rate)
            return estimated_total_rate;
        },
        actualTotal() {
            if (!this.itemModel.start_rental_at || !this.itemModel.actual_returned_at ||!this.itemModel.actual_rental_rate) {
                return null;
            }
            const date1 = new Date(this.itemModel.actual_returned_at);
            const date2 = new Date(this.itemModel.start_rental_at);
            const diff = Math.abs(date1.getTime() - date2.getTime());
            const diffDays = (Math.ceil(diff / (1000 * 3600 * 24))) || 1; 
            console.log(diffDays)
            const actual_total_return_rate = parseInt(diffDays) * parseFloat(this.itemModel.actual_rental_rate)
            return actual_total_return_rate;
        },

        companySetting() {
            const data = this.$store.state.company.settings
            console.log('comp--', data)
            return data
        },
    },
    watch: {
        // entities: function (val) {
        //     console.log('entities--', val)
        // },
        // flows: function (val) {
        //     console.log('flows--', val)
        // },
        // transaction_type: {
        //     handler: function (val) {
        //         console.log('transaction type--', val)
        //     },
        //     deep: true,
        // },

        itemModel: {
            handler: function(val){
                if(val.is_returned){
                    this.itemModel.rental_tax = parseFloat(parseFloat(this.actualTotal) * parseFloat(val.tax_rate) / 100).toFixed(2);
                }else{
                    this.itemModel.estimated_total_rental_tax = parseFloat(parseFloat(this.estimatedTotal) * parseFloat(val.tax_rate) / 100).toFixed(2);
                }
            },
            deep: true,
        },

        'this.$store.state.assets.asset': {
            handler: function (val) {
                this.asset = val
                console.log('asset', val)
            },
            deep: true,
        },
    },

    created() {
        if (parseInt(this.order_id)) {
            // this.$store.dispatch('locations/fetchWarehouses')
        }
        console.log('asset-order-', this.orderModel)
        // this.$store.dispatch('itemType/fetchAll')

    },

    methods: {

        setAsset(asset) {
            console.log('assets-is',asset);
            this.itemModel.asset_id = asset.id;
            this.itemModel.asset_description = asset.description; // Assuming asset has a description property
            this.itemModel.asset = asset;
            this.$store.dispatch('assets/fetch_master_item', { id: asset.id }).then(response => {
               
                // Assuming response contains the master_item_type name
                this.itemModel.master_item_type = response.success.data?.master_item?.name;
                this.itemModel.tax_rate = response.success.data?.master_item?.type.tax_rate;
                this.itemModel.estimated_rental_rate = response.success.data?.master_item?.default_rental_rate;
                this.itemModel.actual_rental_rate = response.success.data?.master_item?.default_rental_rate;
            }).catch(error => {
                console.error('Error fetching master item type:', error);
            });
           
        },
        queryOptionsValue(val) {
            console.log("gettttt", val)
            this.filters.queryOptionsValue = val
            this.lookupAssets()
        },
        //////////////////////
        updateItemType() {
            // this.$set(this.itemModel, 'order_item_type_id', evt)
            this.locationCollapseVisible = false
            this.assetCollapseVisible = false
        },

        showItem(item, { reference_no, order_type_id, viewMode, isReturnMode }) {
            console.log('showItem item before', item)
            this.reference_no = reference_no;
            this.viewMode = viewMode;
            this.order_type_id = order_type_id;
            this.itemVisible = true
            
            isReturnMode = isReturnMode || false
            this.isReturnMode = isReturnMode

            if (item) {
                let {
                    name,
                    tax_rate,
                    estimated_rental_days,
                    estimated_rental_rate,
                    actual_rental_rate,
                    asset,
                    master_item_type,
                    rental_tax,
                } = item
                this.searchedAsset = (name ? name : (asset?.name))
                this.itemModel = {
                    ...defaultItemModel,
                    ...item,
                    name: (name ? name : (asset?.name)),
                    description: asset?.description,
                    asset_description: asset?.description,
                    location_section_id: asset?.location_section_id,
                    tax_rate: tax_rate ?? asset?.master_item?.type?.tax_rate,
                    estimated_total_rental_tax: ((parseFloat(estimated_rental_days) * parseFloat(estimated_rental_rate)) * asset?.master_item?.type?.tax_rate / 100),
                    actual_rental_rate: actual_rental_rate|| estimated_rental_rate,
                    master_item_type: master_item_type ? master_item_type : asset?.master_item?.name,
                    is_returned: this.isReturnMode,
                    rental_tax: !this.isReturnMode ? rental_tax : null,
                }
            } else {
                this.itemModel = {
                    ...defaultItemModel,
                }
            }
            console.log('showItem after itemModel',this.searchedAsset, this.itemModel)

            //////////////////
            // const section_to_id = this.itemModel.section_to_id || this.orderModel.delivery_location_section_id
            // this.$set(this.itemModel, 'section_to_id', section_to_id)
            // this.masterItem = this.$store.state.masterItem
        },

        handleOk(evt) {
            // Prevent modal from closing
            evt.preventDefault()
            console.log('yes----=====')
            // Trigger submit handler
            this.handleSubmit()
        },


        async handleSubmit() {
            // Exit when the form isn't valid
            try {
                this.submitting = true
                const { itemModel, locationData } = this
                console.log('locationData-', locationData)
                await this.mergeItem({ ...itemModel, locationData })
                if(itemModel.is_returned){
                    this.$parent.$emit('return-item-submitted', true);
                }
                console.log('yes=======')
                this.itemVisible = false
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.submitting = false
            }
        },

        async mergeItem(item) {
            
            try {
                console.log('add item-', item)
                this.submitting = true

                // item.price = parseFloat(item.price) || 0
                // item.quantity = parseInt(item.quantity) || 0

                if (!item.asset_id) {
                    throw new Error(this.$translate('asset_required'))
                }
                   
                await this.$store.dispatch('orderRentalAssetStore/merge', item)
                await this.$nextTick()
                
                this.$emit('item-added', true);
                console.log('stored_items_data',this.$store.getters['orderItemStore/itemsOnly']);
                // console.log('stored_asset_data',this.$store.getters['orderRentalAssetStore/itemsOnly']);
                this.itemVisible = false
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.submitting = false
            }
        },
        lookupAssets: debounce(function () {
            // in practice this action should be debounced
            let { searchedAsset: query, filters } = this
            delete filters.customer_id;
            query = query.split('-')[0] 
            this.$store.dispatch('assets/fetch', {  query, filters })
        }, 500),
    },
}
</script>
